import React, { useState, useEffect } from "react";
import "./index.scss";
import ArrowDownIcon from "../../svgs/arrow-down.svg";
import SearchIcon from "../../svgs/search.svg";
import AddCircleIcon from "../../svgs/add-circle.svg";
import ChargingPlanList from "./components/ChargingPlanList";
import CreateChargingPlanModal from "./components/CreateChargingPlanModal";
import useDebounce from "../../../Shared/GeographyFilters/hooks/useDebounce";

const planStatuses = [
  {
    value: "",
    label: "All Statuses",
  },
  {
    value: "active",
    label: "Active",
  },
  {
    value: "inactive",
    label: "Deactivated",
  },
];

const ChargingPlan = () => {
  const [showChargingPlanCreateModal, setShowChargingPlanCreateModal] =
    useState(false);
  const [localSearchTerm, setLocalSearchTerm] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [planStatus, setPlanStatus] = useState("");
  const [planListKey, setPlanListKey] = useState(0);
  const userType = JSON.parse(localStorage.getItem("currUserType"));
  const debouncedSearchTerm = useDebounce(localSearchTerm, 400);

  useEffect(() => {
    setSearchTerm(debouncedSearchTerm);
  }, [debouncedSearchTerm]);

  const handlePlanCreated = () => {
    setPlanListKey((prev) => prev + 1);
  };

  return (
    <div className="content-section">
      <div className="content-header">
        <div></div>
        <div className="filters-section">
          <div className="select-wrapper">
            <select
              id="plan-status"
              value={planStatus}
              onChange={(e) => setPlanStatus(e.target.value)}
              className="select-field"
            >
              {planStatuses.map((status) => (
                <option key={status.value} value={status.value}>
                  {status.label}
                </option>
              ))}
            </select>
            <img
              src={ArrowDownIcon}
              alt="Select Icon"
              className="select-icon"
            />
          </div>
          <div className="search-input">
            <img src={SearchIcon} alt="Search Icon" className="search-icon" />
            <input
              type="text"
              id="plan-search"
              value={localSearchTerm}
              onChange={(e) => setLocalSearchTerm(e.target.value)}
              placeholder="Search"
              className="search-input-field"
            />
          </div>
          {userType === "bkash-super-user" && (
            <button
              className="create-btn"
              onClick={() => setShowChargingPlanCreateModal(true)}
            >
              <img src={AddCircleIcon} alt="Search Icon" className="btn-icon" />
              Create New Charging Plan
            </button>
          )}
        </div>
      </div>
      <div className="content-body">
        <ChargingPlanList
          key={planListKey}
          searchTerm={searchTerm}
          planStatus={planStatus}
          onPlanCreated={handlePlanCreated}
        />
      </div>

      {showChargingPlanCreateModal && (
        <CreateChargingPlanModal
          showChargingPlanCreateModal={showChargingPlanCreateModal}
          setShowChargingPlanCreateModal={setShowChargingPlanCreateModal}
          onPlanCreated={handlePlanCreated}
        />
      )}
    </div>
  );
};

export default ChargingPlan;
